export default __webpack_public_path__ + "static/62-3e133362c1f7d36bcb359f8f35b11837.png";